import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { Billing } from '@eadsysteme/billingclient-v1';

export interface BillingSelectDialogData {
	billings: Billing[];
}

@Component({
	selector: 'app-billing-select-dialog',
	imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslocoModule, CdkDrag, CdkDragHandle],
	templateUrl: './billing-select-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./billing-select-dialog.component.scss'],
})
export class BillingSelectDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<BillingSelectDialogComponent>);
	private readonly router = inject(Router);
	readonly data: BillingSelectDialogData = inject(MAT_DIALOG_DATA);

	selectBilling(billing: Billing): void {
		this.dialogRef.close();
		this.router.navigate(['/billing-units/' + billing.exportId]);
	}

	close(): void {
		this.dialogRef.close();
	}
}
